// extracted by mini-css-extract-plugin
export default {"icon":"Home_icon__eBZgB"};